// extracted by mini-css-extract-plugin
export default {"dentistCard":"dentistCardStyles_dentistCard__doqXR","dentistDetails":"dentistCardStyles_dentistDetails__EHjBX"};